import {useCallback} from "react";
import dayjs from "dayjs";
import {
	DateRangeField,
	SelectField
} from "~/components/Forms";
import {
	strToTime,
	getGroupSelectOption
} from "~/utils";

const statusOptions = [
	{value: '', label: 'Tất cả nhân viên'},
	{value: 'working', label: 'Nhân viên đang làm'},
	{value: 'resign', label: 'Nhân viên đã nghỉ'},
];

const companyOptions = [
	{value: '', label: 'Tất cả công ty'},
	{value: 1, label: 'SiKiDo'},
	{value: 2, label: 'D&H'},
];

const groupTypeOptions = [
	{value: 'group', label: 'Xem theo nhóm'},
	{value: 'tree', label: 'Xem theo nhánh'},
];

//Chỉ các chức vụ thuộc khối kinh doanh
const roleOptions = [
	{value: '', label: 'Tất cả chức vụ'},
	{value: 'sales', label: 'Kinh doanh'},
	{value: 'salesLeader', label: 'Nhóm trưởng'},
	{value: 'salesManager', label: 'Quản lý'},
	{value: 'salesSenior', label: 'Trưởng phòng'},
	{value: 'salesSupper', label: 'Trưởng khu vực'},
];

function StaffSummarySearch({filter, listGroup, userOptions = [], onChange}) {

	const groupOptions = Object.values(getGroupSelectOption(listGroup));

	const timeValue = (Array.isArray(filter.time) && filter.time.length === 2)
		? [dayjs.unix(filter.time[0]), dayjs.unix(filter.time[1])]
		: null;

	const handleTimeChange = useCallback((value) => {
		if(!value) {
			if(onChange) onChange('time', undefined);
			return;
		}
		let valueNew = [...value];
		valueNew[0] = strToTime(valueNew[0]);
		valueNew[1] = strToTime(valueNew[1]);
		if(onChange) onChange('time', valueNew);
	}, [onChange]);

	const handleChange = useCallback((key, value) => {
		if(onChange) onChange(key, value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<form className="form" autoComplete="off">
				<DateRangeField name="time" value={timeValue} onChange={(value) => handleTimeChange(value)} />
				<SelectField defaultValue={filter.companyId || ''} placeholder="Công ty" options={companyOptions} onChange={(value) => handleChange('companyId', value)} />
				<SelectField defaultValue={filter.groupType || 'group'} placeholder="Loại lọc nhóm" options={groupTypeOptions} onChange={(value) => handleChange('groupType', value)} />
				<SelectField defaultValue={filter.groupId} placeholder="Chọn nhóm" options={groupOptions} onChange={(value) => handleChange('groupId', value)} />
				<SelectField defaultValue={filter.role || ''} placeholder="Chức vụ" options={roleOptions} onChange={(value) => handleChange('role', value)} />
				<SelectField defaultValue={filter.userStatus || ''} placeholder="Trạng thái làm việc" options={statusOptions} onChange={(value) => handleChange('userStatus', value)} />
				<SelectField
					defaultValue={filter.userId}
					placeholder="Chọn nhân viên"
					options={[{value: '', label: 'Tất cả nhân viên'}, ...userOptions]}
					onChange={(value) => handleChange('userId', value)}
				/>
			</form>
		</div>
	)
}

export default StaffSummarySearch;
